export default function Projects() {
  const projectsList = [
    {
      id: 1,
      title: "AI Environmental Monitoring System",
      description:
        "AI-powered system for monitoring and analyzing environmental data in real-time.",
      image:
        "https://plus.unsplash.com/premium_photo-1711987513962-db5c9f9139b6?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      github: "https://github.com/himanshuji003/prana-net",
      technologies: ["React", "Node.js", "MongoDB", "Ollama"],
    },
    {
      id: 2,
      title: "Biometric Payment System",
      description:
        "A secure biometric payment system that uses fingerprint and facial recognition for authentication.",
      image:
        "https://images.unsplash.com/photo-1556740720-776b84291f8e?q=80&w=1171&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      github: "https://github.com/himanshvasisht/bipay",
      technologies: [
        "React",
        "Firebase",
        "Tailwind CSS",
        "Express",
        "Node.js",
        "Python",
        "OpenCV",
      ],
    },
    {
      id: 3,
      title: "Social Media Dashboard",
      description:
        "Analytics dashboard for managing multiple social media accounts with real-time statistics and insights.",
      image:
        "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=500&h=300&fit=crop",
      github: "https://github.com",
      technologies: ["Next.js", "PostgreSQL", "Chart.js"],
    },
    {
      id: 4,
      title: "Full-Stack Business Website",
      description:
        "A modern, responsive business website built with React and Node.js, featuring a custom CMS for easy content management.",
      image:
        "https://images.unsplash.com/photo-1642132652860-471b4228023e?q=80&w=2060&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      github: "https://github.com/himanshuji003/AcTechWeb",
      technologies: ["React", "Node.js", "MongoDB", "Express"],
    },
    {
      id: 5,
      title: "Video Streaming Platform",
      description:
        "Scalable video streaming platform with adaptive bitrate streaming and user engagement analytics.",
      image:
        "https://plus.unsplash.com/premium_photo-1721225464894-46e7bb29e446?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      github: "https://github.com/himanshuji003/",
      technologies: ["HLS.js", "Node.js", "AWS", "React"],
    },
    {
      id: 6,
      title: "Fitness Tracking App",
      description:
        "Mobile-first fitness app with workout tracking, progress analytics, and social features.",
      image:
        "https://images.unsplash.com/photo-1571902943202-507ec2618e8f?w=500&h=300&fit=crop",
      github: "https://github.com",
      technologies: ["React Native", "Firebase", "Redux"],
    },
  ];

  return (
    <section
      id="projects"
      className="relative bg-[#0b0b0b] py-28 overflow-hidden text-white"
    >
      {/* Animated Background */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(255,180,80,0.12),transparent_60%)] animate-pulse" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_right,rgba(0,200,200,0.08),transparent_70%)]" />

      {/* Floating elements */}
      <div className="absolute top-1/4 left-10 w-80 h-80 bg-orange-400/10 rounded-full blur-3xl animate-float opacity-20" />
      <div
        className="absolute bottom-1/3 right-10 w-72 h-72 bg-cyan-400/10 rounded-full blur-3xl animate-float opacity-20"
        style={{ animationDelay: "1.5s" }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <h2 className="text-center text-6xl font-bold mb-24 tracking-wide">
          <span className="text-gray-300">My</span>{" "}
          <span className="text-transparent bg-linear-to-r from-orange-400 to-cyan-400 bg-clip-text">
            Projects
          </span>
        </h2>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projectsList.map((project, index) => (
            <div
              key={project.id}
              className="group relative rounded-2xl overflow-hidden glass-morphism border border-white/20 hover:border-cyan-400/50 transition-all duration-300 hover:shadow-[0_0_30px_rgba(0,200,200,0.4)] hover:scale-105 animate-fade"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Project Image */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-linear-to-t from-black via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>

              {/* Project Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-transparent mb-2 bg-linear-to-r from-orange-400 to-cyan-400 bg-clip-text transition-all">
                  {project.title}
                </h3>

                <p className="text-gray-400 text-sm mb-4 leading-relaxed">
                  {project.description}
                </p>

                {/* Technologies */}
                <div className="flex flex-wrap gap-2 mb-6">
                  {project.technologies.map((tech, i) => (
                    <span
                      key={i}
                      className="text-xs px-3 py-1 rounded-full bg-white/10 border border-cyan-400/70 text-gray-300 group-hover:border-cyan-400 transition-colors"
                    >
                      {tech}
                    </span>
                  ))}
                </div>

                {(() => {
                  const liveLink = project.live || project.repo?.homepage;
                  const githubLink = project.github || project.repo?.html_url;

                  if (!liveLink && !githubLink) {
                    return null;
                  }

                  return (
                    <div className="flex flex-wrap gap-3">
                      {liveLink ? (
                        <a
                          href={liveLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex-1 min-w-28 rounded-lg bg-linear-to-r from-orange-300 via-amber-300 to-cyan-300 px-4 py-2 text-center text-sm font-bold text-black shadow-[0_18px_50px_rgba(0,200,200,0.25)] transition-all duration-300 hover:shadow-[0_22px_60px_rgba(0,200,200,0.35)]"
                        >
                          Live
                        </a>
                      ) : null}

                      {githubLink ? (
                        <a
                          href={githubLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex-1 min-w-28 rounded-lg bg-linear-to-r from-orange-300 via-amber-300 to-cyan-300 px-4 py-2 text-center text-sm font-semibold text-black shadow-[0_18px_50px_rgba(0,200,200,0.25)] transition-all duration-300 hover:shadow-[0_22px_60px_rgba(0,200,200,0.35)]"
                        >
                          GitHub
                        </a>
                      ) : null}
                    </div>
                  );
                })()}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom Fade */}
      <div className="absolute bottom-0 left-0 w-full h-40 bg-linear-to-t from-black to-transparent" />
    </section>
  );
}
